export interface BulkInsertOptions {
    useCompression?: boolean;
    skipOverwriteIfUnchanged?: boolean;
}